import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: 800, margin: '50px auto', lineHeight: 1.6, padding: '0 16px' }}>
      <h1>Privacy Policy</h1>
      <p>
        We collect your personal and financial information—such as full name, email, phone number,
        mortgage type, property details, income, debts, and existing properties—solely to pre-qualify
        you for a mortgage and to provide personalized quotes.
      </p>
      <p>
        This data is stored securely in our database and shared only with the mortgage agent you specify.
        We do not sell or rent your information to third parties. By checking the consent box on the form,
        you explicitly agree to this data collection and sharing. You may request deletion or correction
        of your data at any time by contacting us at <a href="mailto:privacy@yourdomain.com">privacy@yourdomain.com</a>.
      </p>
      <p>
        If you have any questions or concerns about how we handle your data, please reach out to our compliance team.
      </p>
    </div>
  );
}
